/* eslint-disable react/no-array-index-key */
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { useRouter } from 'next/router';

import { useSidebar } from '~/layouts/private/providers/sidebar';
import { usePrivateLayout } from '~/layouts/private/providers/privateLayout';

import { ISidebarItem } from '~/common/interfaces/ISidebarItem';
import { sidebar } from '~/common/constants/sidebar';
import { GenericMenuItem } from '~/common/components/GenericMenuItem';

import { ChildrenList, SubmenuListItem } from './styles';

interface ISidebarSubmenuProps {
  submenu: ISidebarItem;
  index: number;
  refflect: (refflected: ISidebarItem[]) => void;
}
export const SidebarSubmenu: FC<ISidebarSubmenuProps> = ({
  submenu,
  index,
  refflect,
}) => {
  const { isMobile } = usePrivateLayout();
  const { asPath } = useRouter();
  const { collapsed, collapse: collapseSidebar } = useSidebar();
  const [open, setOpen] = useState<boolean>(false);

  const colapse = useCallback(() => {
    setOpen((prev) => {
      const newState = !prev;
      refflect(
        sidebar.map((nav) => ({
          ...nav,
          ...(nav.key === submenu.key && {
            open: newState,
          }),
        }))
      );

      return newState;
    });

    if (collapsed) {
      collapseSidebar();
    }
  }, [collapsed, submenu, refflect, collapseSidebar]);

  useEffect(() => {
    if (collapsed) {
      setOpen(false);
      refflect(
        sidebar.map((nav) => ({
          ...nav,
          ...(nav.key === submenu.key && {
            open: false,
          }),
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed]);

  useEffect(() => {
    if (open) {
      const split = asPath.split('/');
      if (split.length === 1) {
        colapse();
      }
    }
  }, [open, asPath, colapse]);

  const submenuLength = useMemo(
    () => (isMobile ? submenu.children.length - 1 : submenu.children.length),
    [isMobile, submenu]
  );

  return (
    <SubmenuListItem
      style={{
        height: open ? `${36 + submenuLength * 36}px` : '36px',
      }}
    >
      <GenericMenuItem
        id={submenu.key}
        withoutIconHighligh
        as="div"
        icon={submenu.icon}
        customIcon={submenu.customIcon}
        title={submenu.label}
        index={index}
        selected={open}
        key={String(index)}
        onClick={colapse}
        arrowState={open ? 'top' : 'bottom'}
        compact={collapsed}
      />

      <ChildrenList
        open={open}
        height={open ? `${submenuLength * 36}px` : '0px'}
      >
        {submenu.children.map((sub, _index) => {
          if (sub.key === 'moneyflow' && isMobile) {
            return null; // Skip rendering for 'moneyflow' on mobile
          }

          return (
            <GenericMenuItem
              id={sub.key}
              transparentBackground
              key={String(_index)}
              index={_index}
              title={sub.label}
              href={`/${submenu.key}/${sub.key}`}
              selected={false}
              paddingLeft="36px"
              hoverColor="neutral.700"
              compact={collapsed}
            />
          );
        })}
      </ChildrenList>
    </SubmenuListItem>
  );
};
